import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { DolorReal } from '../components/DolorReal';
import { CausaReal } from '../components/CausaReal';
import { Timeline } from '../components/Timeline';
import { Ingredientes } from '../components/Ingredientes';
import { PruebaSocial } from '../components/PruebaSocial';
import { Resultados } from '../components/Resultados';
import { Testimonios } from '../components/Testimonios';
import { Diferenciacion } from '../components/Diferenciacion';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="min-h-screen bg-white font-sans text-gray-900 selection:bg-esbelta-violet/20" data-id="element-305">
      <AnnouncementBar data-id="element-306" />
      <Header data-id="element-307" />
      <Hero data-id="element-308" />
      <DolorReal data-id="element-309" />
      <CausaReal data-id="element-310" />
      <Timeline data-id="element-311" />
      <Ingredientes data-id="element-312" />
      <PruebaSocial data-id="element-313" />
      <Resultados data-id="element-314" />
      <Testimonios data-id="element-315" />
      <Diferenciacion data-id="element-316" />
      <FAQ data-id="element-317" />
      <Footer data-id="element-318" />
    </main>;
}